import { baseBackend } from "../../../../../api/base/baseUrl";

const RATES_CLIENT_CITY_RANGE_URL = "/api/v2/rates/clients/city_range";

export async function getClientCityRangeListRequest() {
  const response = await baseBackend.get(RATES_CLIENT_CITY_RANGE_URL);
  return response.data;
}

export async function createClientCityRangeRequest(payload) {
  const response = await baseBackend.post(
    RATES_CLIENT_CITY_RANGE_URL,
    payload,
  );
  return response.data;
}

export async function updateClientCityRangeRequest(payload) {
  const response = await baseBackend.put(
    RATES_CLIENT_CITY_RANGE_URL,
    payload,
  );
  return response.data;
}

export async function deleteClientCityRangeRequest(id) {
  const response = await baseBackend.delete(
    `${RATES_CLIENT_CITY_RANGE_URL}/id/${id}`,
  );
  return response.data;
}
